import { useCallback } from 'react';

const useHeadResourceLoader = () => {
  const loadScript = useCallback(src => {
    // Verificar si el script ya existe en el documento
    if (document.querySelector(`script[src="${src}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    document.head.appendChild(script);
  }, []);

  const loadStyle = useCallback(href => {
    // Verificar si el estilo ya existe en el documento
    if (document?.querySelector(`link[href="${href}"]`)) {
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;

    document.head.appendChild(link);
  }, []);

  return { loadScript, loadStyle };
};

export default useHeadResourceLoader;
